import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const browserPreviewWidgetDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),
  };
};
